import InputTranslationEditor from './InputTranslationEditor';

export default InputTranslationEditor;
